import React, { type ReactNode } from 'react'

function ArrowDown(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      stroke="var(--color-text-primary)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 1.5L7.5 7.5L13.5 1.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArrowDown
